import { useSelector } from "react-redux";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { usePublicSession } from "../context/PublicSessionContext";

export const useSubscriptionAccess = () => {
  const authUser = useAuthUser();
  const { user = {} } = authUser ?? {};
  const { isPublicView } = usePublicSession() ?? {};
  const hasSubscription = useSelector((state) => state.user.hasSubscription);
  const hasUsedFreeTrial = useSelector((state) => state.user.hasUsedFreeTrial);
  const role = String(user?.role ?? "").toLowerCase();
  const isHighSchoolCoach = role === "highschool";
  const isAthlete = role === "athlete";
  const hasSubscriptionAccess = Boolean(
    isPublicView || hasSubscription || isHighSchoolCoach,
  );
  const showFreeTrial =
    !hasSubscriptionAccess && isAthlete && !hasUsedFreeTrial;

  return {
    authUser,
    user,
    isPublicView,
    isHighSchoolCoach,
    hasSubscription,
    hasUsedFreeTrial,
    hasSubscriptionAccess,
    showFreeTrial,
  };
};
